// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"49":"913d61a5","91":"c6f2bd54","98":"c7fdb1cd","305":"f0e14fe9","374":"0b8fb3f6","521":"19e76c55","996":"76f5a0ad"}[chunkId] + ".js";
};